import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from './../../../../environments/environment';
import { ListaImagenes } from './../../../_entities/galeria/ListaImagenes';
import { Autos } from './../../../_entities/autos/Autos';
import { ClienteConsola } from './../../../_entities/consola/cliente-consola';
import { VehiculoCliente } from './../../../_entities/consola/vehiculo-cliente';

@Injectable({
	providedIn: 'root'
})
export class GaleriaService {

	constructor(private http: HttpClient) { }

	obtenerClientes(): Observable<ClienteConsola[]> {
		return this.http.get<ClienteConsola[]>(environment.API_SECURITY + '/api/Consola/ClientesConsola');
	}

	obtenerVehiculos(idCliente): Observable<VehiculoCliente[]> {
		return this.http.get<VehiculoCliente[]>(environment.API_SECURITY + '/api/Consola/VehiculosFoto/' + idCliente);
	}

	/*Obtener Todas las imagenes-*/
	obtenerListaImagenes(imei): Observable<ListaImagenes[]> {
		return this.http.get<ListaImagenes[]>(environment.API_SECURITY + '/api/Imagenes', {
			params: {
				imei: imei
			}
		})
	}

	/**Obtener Imagen Especifica */
	obtenerImagenEspecifica(imei, foto) {
		return this.http.get(environment.API_SECURITY + '/api/Imagenes/ObtenerImagen', {
			responseType: 'blob', params: {
				imei: imei,
				imagen: foto
			}
		})
	}


}
